import { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Modal,
    Box,
    CircularProgress,
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Paper,
    Typography
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { DiseñoDataGrid } from "../../Components/FuncionesGenerales/DataGrid";

import {
    buttonGuardar,
    TituloColor,
    Input,
    modalStyle,
    buttonCancelar
} from "../../Layouts/CustomStyles";

import { useProfesional, useGetProfesional } from "../../Services/Profesional";
import { useGetSucursal } from "../../Services/Sucursales";
import { useGetServiciosClinicos } from "../../Services/ServicioClinico";
import { FaTrashCan } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { BiErrorCircle } from "react-icons/bi";
import { FaRegCircleCheck } from "react-icons/fa6";
/* funciones generales */
import { FormatRut } from "../FuncionesGenerales/Rut";

export const FuncionProfesional = ({ abrirdialog, closedialog }) => {
    const { postProfesional, editarProfesional, eliminarProfesional } = useProfesional();
    const { profesional, loadings, refetch } = useGetProfesional();
    const { servicios } = useGetServiciosClinicos();
    const { sucursales } = useGetSucursal();
    const [successAlertOpen, setSuccessAlertOpen] = useState(false);
    const [errorAlertOpen, setErrorAlertOpen] = useState(false);
    const [enviandoAlert, setEnviandoAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [openConfirm, setOpenConfirm] = useState(false);
    const [selectedProfesional, setSelectedProfesional] = useState(null);
    const [openEditDialog, setOpenEditDialog] = useState(false);
    // ❌ ERROR: usabas [] en lugar de {}
    const [formData, setFormData] = useState({
        nombre: "",
        nombre_completo: "",
        email: "",
        rut: "",
        id_area_servicio: "",
        sucursal_uno: "",
        sucursal_dos: "",
    });

    

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "rut") {
            // aplicar formato automático
            const formatted = FormatRut(value);
            setFormData((prev) => ({ ...prev, [name]: formatted }));
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setEnviandoAlert(true);

        try {
            // ✅ No necesitas las llaves extra en { formData }
            await postProfesional(formData);

            setAlertMessage("Profesional creado exitosamente.");
            setSuccessAlertOpen(true);
            closedialog();
            await refetch();
             setFormData({
            nombre: "",
            nombre_completo: "",
            email: "",
            rut: "",
            id_area_servicio: "",
            sucursal_uno: "",
            sucursal_dos: "",
        });
        } catch (error) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                "Error al crear Profesional";

            setAlertMessage(message);
            setErrorAlertOpen(true);
        } finally {
            setEnviandoAlert(false);
        }
    };


      const handleDelete = (prof) => {
        setSelectedProfesional(prof);
        setOpenConfirm(true);
    };

    const confirmDelete = async () => {
        if (!selectedProfesional) return;
        await eliminarProfesional(selectedProfesional.id);
        setOpenConfirm(false);
        await refetch();
    };

    const handleEdit = (prof) => {
    setSelectedProfesional(prof);
    setFormData({
        nombre: prof.nombre,
        nombre_completo: prof.nombre_completo,
        email: prof.email,
        rut: prof.rut,
        id_area_servicio: prof.id_area_servicio,
        sucursal_uno: prof.sucursal_uno,
        sucursal_dos: prof.sucursal_dos,
    });
    setOpenEditDialog(true);
};

// Guardar cambios de edición
const handleUpdate = async (e) => {
    e.preventDefault();
    if (!selectedProfesional) return;
    setEnviandoAlert(true);

    try {
        await editarProfesional(selectedProfesional.id, formData);
        setAlertMessage("Profesional actualizado exitosamente.");
        setSuccessAlertOpen(true);
        setOpenEditDialog(false);
        await refetch();
        setFormData({
            nombre: "",
            nombre_completo: "",
            email: "",
            rut: "",
            id_area_servicio: "",
            sucursal_uno: "",
            sucursal_dos: "",
        });
    } catch (error) {
        const message =
            error?.response?.data?.message ||
            error?.message ||
            "Error al actualizar profesional";
        setAlertMessage(message);
        setErrorAlertOpen(true);
    } finally {
        setEnviandoAlert(false);
    }
};


 const columns = [
        {
            field: "nombre",
            headerName: "Nombre",
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
         {
            field: "nombre_completo",
            headerName: "nombre completo",
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "rut",
            headerName: "RUT",
            flex: 0.7,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "email",
            headerName: "Email",
            flex: 1,
            headerAlign: "center",
            align: "center",
        },
        {
            field: "servicio_clinico",
            headerName: "Área Servicio",
            flex: 1,
            headerAlign: "center",
            align: "center",
           
        },
        {
            field: "sucursales",
            headerName: "Sucursal(es)",
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => (
                <div style={{ display: "flex", flexDirection: "column", textAlign: "left" }}>
                    {params.row.sucursal_uno}
                    {params.row.sucursal_dos}
                </div>
            ),
        },
        {
            field: "acciones",
            headerName: "Acciones",
            flex: 0.6,
            headerAlign: "center",
            align: "center",
            sortable: false,
            renderCell: (params) => (
                <div className="contiene-buton" style={{ display: "flex", gap: "8px" }}>
                    <button className="edit-button" onClick={() => handleEdit(params.row)}>
                        <svg className="edit-svgIcon" viewBox="0 0 512 512">
                            <path d="M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32z" />
                        </svg>
                    </button>

                    <button className="delete-button" onClick={() => handleDelete(params.row)}>
                        <FaTrashCan className="delete-svgIcon" />
                    </button>
                </div>
            ),
        },
    ];
    return (
        <Box >
            
              <Paper sx={{ p: 2, mt: 2 }}>
                {loadings ? (
                    <Box sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                        <CircularProgress />
                    </Box>
                ) : profesional.length === 0 ? (
                    <Typography sx={{ textAlign: "center", color: "#888" }}>
                        No hay profesionales registrados
                    </Typography>
                ) : (
                                  <div style={{ width: "100%", height: 600 }}>
                    <DataGrid
                        rows={profesional}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[10, 20, 50]}
                        disableRowSelectionOnClick
                         slots={{ noRowsOverlay: DiseñoDataGrid }}
                        sx={{
    fontFamily: "Poppins, sans-serif",
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: "#f0f0f0",
      fontWeight: 600,
    },
    "& .nopagado": {
      bgcolor: "#FFA50033", // fondo naranja clarito
      "&:hover": { bgcolor: "#FFA50055" }, // más intenso al pasar el mouse
    },
  }}
                    />
                </div>

                )}
            </Paper>

                {/* crear profesional */}
            <Dialog open={abrirdialog} onClose={closedialog} fullWidth maxWidth="md">
                <DialogTitle sx={TituloColor}>Agregar Nuevo Profesional</DialogTitle>
                <form onSubmit={handleSubmit}>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <TextField
                                    sx={Input}
                                    fullWidth
                                    label="Nombre (seudónimo si es kinesiólogo o nutrición)"
                                    name="nombre"
                                    value={formData.nombre}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid size={12}>
                                <TextField
                                    sx={Input}
                                    fullWidth
                                    label="Nombre completo (si es kinesiólogo o nutrición)"
                                    name="nombre_completo"
                                    value={formData.nombre_completo}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid size={12}>
                                <TextField
                                    sx={Input}
                                    fullWidth
                                    label="RUT "
                                    name="rut"
                                    value={formData.rut}
                                    onChange={handleChange}
                                    placeholder="12.345.678-9"
                                />
                            </Grid>

                            <Grid size={12}>
                                <TextField
                                    sx={Input}
                                    fullWidth
                                    label="Email"
                                    name="email"
                                    type="email"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid size={12}>

                                <FormControl fullWidth sx={Input}>
                                    <InputLabel id="sucursal-label">Área de servicio</InputLabel>
                                    <Select
                                        labelId="sucursal-label"
                                        name="id_area_servicio"
                                        value={formData.id_area_servicio}
                                        onChange={handleChange}
                                        label="Sucursal"
                                    >

                                        {servicios?.map((s) => (
                                            <MenuItem key={s.id} value={s.id}>
                                                {s.nombre} {/* ajusta según el campo de tu sucursal */}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid size={12}>
                                <FormControl fullWidth sx={Input}>
                                    <InputLabel id="sucursal-label">Sucursal</InputLabel>
                                    <Select
                                        labelId="sucursal-label"
                                        name="sucursal_uno"
                                        value={formData.sucursal_uno}
                                        onChange={handleChange}
                                        label="Sucursal"
                                    >

                                        {sucursales?.map((s) => (
                                            <MenuItem key={s.id} value={s.name}>
                                                {s.name} {/* ajusta según el campo de tu sucursal */}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </Grid>

                            <Grid size={12}>
                                <FormControl fullWidth sx={Input}>
                                    <InputLabel id="sucursal-label">Sucursal (opcional, si el profesional trabaja en un segundo secursal indicar si no dejar vació)</InputLabel>
                                    <Select
                                        labelId="sucursal-label"
                                        name="sucursal_dos"
                                        value={formData.sucursal_dos}
                                        onChange={handleChange}
                                        label="Sucursal"
                                    >
                                        <MenuItem value="">General</MenuItem> {/* opción por defecto */}
                                        {sucursales?.map((s) => (
                                            <MenuItem key={s.id} value={s.name}>
                                                {s.name} {/* ajusta según el campo de tu sucursal */}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                    </DialogContent>
                 <DialogActions >
                    <Button
                        sx={buttonGuardar}
                        type="submit"
                        disabled={enviandoAlert}
                    >
                        {enviandoAlert ? <CircularProgress size={24} /> : "Guardar"}
                    </Button>

                    <Button
                        sx={buttonCancelar}
                        onClick={closedialog}
                    >
                        Cancelar
                    </Button>
                </DialogActions>
                </form>
            </Dialog>
            {/* editar profesional  */}
            <Dialog open={openEditDialog} onClose={() => setOpenEditDialog(false)} fullWidth maxWidth="md">
    <DialogTitle sx={TituloColor}>Editar Profesional</DialogTitle>
    <form onSubmit={handleUpdate}>
        <DialogContent>
            <Grid container spacing={2}>
                <Grid size={12}>
                    <TextField
                        sx={Input}
                        fullWidth
                        label="Nombre (seudónimo si es kinesiólogo o nutrición)"
                        name="nombre"
                        value={formData.nombre}
                        onChange={handleChange}
                    />
                </Grid>
                 <Grid size={12}>
                                <TextField
                                    sx={Input}
                                    fullWidth
                                    label="Nombre completo (si es kinesiólogo o nutrición)"
                                    name="nombre_completo"
                                    value={formData.nombre_completo}
                                    onChange={handleChange}
                                />
                            </Grid>
                <Grid size={12}>
                    <TextField
                        sx={Input}
                        fullWidth
                        label="RUT"
                        name="rut"
                        value={formData.rut}
                        onChange={handleChange}
                        placeholder="12.345.678-9"
                    />
                </Grid>
                <Grid size={12}>
                    <TextField
                        sx={Input}
                        fullWidth
                        label="Email"
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                    />
                </Grid>
                <Grid size={12}>
                    <FormControl fullWidth sx={Input}>
                        <InputLabel id="area-label">Área de servicio</InputLabel>
                        <Select
                            labelId="area-label"
                            name="id_area_servicio"
                            value={formData.id_area_servicio}
                            onChange={handleChange}
                        >
                            {servicios?.map((s) => (
                                <MenuItem key={s.id} value={s.id}>
                                    {s.nombre}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={12}>
                    <FormControl fullWidth sx={Input}>
                        <InputLabel id="sucursal1-label">Sucursal 1</InputLabel>
                        <Select
                            labelId="sucursal1-label"
                            name="sucursal_uno"
                            value={formData.sucursal_uno}
                            onChange={handleChange}
                        >
                            {sucursales?.map((s) => (
                                <MenuItem key={s.id} value={s.name}>
                                    {s.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid size={12}>
                    <FormControl fullWidth sx={Input}>
                        <InputLabel id="sucursal2-label">Sucursal 2 (opcional)</InputLabel>
                        <Select
                            labelId="sucursal2-label"
                            name="sucursal_dos"
                            value={formData.sucursal_dos}
                            onChange={handleChange}
                        >
                            <MenuItem value="">General</MenuItem>
                            {sucursales?.map((s) => (
                                <MenuItem key={s.id} value={s.name}>
                                    {s.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button sx={buttonGuardar} type="submit" disabled={enviandoAlert}>
                {enviandoAlert ? <CircularProgress size={24} /> : "Actualizar"}
            </Button>
            <Button sx={buttonCancelar} onClick={() => setOpenEditDialog(false)}>
                Cancelar
            </Button>
        </DialogActions>
    </form>
</Dialog>

             <Modal open={openConfirm} onClose={() => setOpenConfirm(false)}>
                <Box sx={modalStyle}>
                    <Typography sx={{ mb: 2 }}>¿Seguro que quieres eliminar este profesional?</Typography>
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Button sx={buttonCancelar} onClick={() => setOpenConfirm(false)}>
                            Cancelar
                        </Button>
                        <Button sx={buttonGuardar} onClick={confirmDelete}>
                            Eliminar
                        </Button>
                    </Box>
                </Box>
            </Modal>
            <Modal open={successAlertOpen} onClose={() => setSuccessAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setSuccessAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: "center" }}>
                        <FaRegCircleCheck style={{ color: "green", fontSize: "2rem" }} />
                        <p className="alert-text">{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            <Modal open={errorAlertOpen} onClose={() => setErrorAlertOpen(false)}>
                <Box sx={modalStyle}>
                    <section className="closemodal" onClick={() => setErrorAlertOpen(false)}>
                        <IoClose />
                    </section>
                    <section style={{ textAlign: "center" }}>
                        <BiErrorCircle style={{ color: "red", fontSize: "2rem" }} />
                        <p className="alert-text">{alertMessage}</p>
                    </section>
                </Box>
            </Modal>

            <Modal open={enviandoAlert}>
                <Box sx={modalStyle}>
                    <section style={{ textAlign: "center", padding: "1rem" }}>
                        <CircularProgress style={{ color: "#2a8d74" }} />
                        <p className="alert-text">Procesando solicitud...</p>
                    </section>
                </Box>
            </Modal>
        </Box>
    );
};
